import { render } from "./MedicineDetailContent.vue?vue&type=template&id=75625420&scoped=true"
import script from "./MedicineDetailContent.vue?vue&type=script&lang=js"
export * from "./MedicineDetailContent.vue?vue&type=script&lang=js"

import "./MedicineDetailContent.vue?vue&type=style&index=0&id=75625420&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\moolng-cms-parent\\moolng-lunzhongyi-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75625420"]])

export default __exports__